import { FaPhone, FaEnvelope } from "react-icons/fa";
import "./contactSupport.css";

const ContactSupport = () => {
  return (
    <div className="contact-support-container">
      <div className="contact-support-card">
        <h1>Contact Us</h1>
        <p>
          <FaPhone className="icon" /> Call us: 0172-5100108, 98769-80108
        </p>
        <p>
          <FaEnvelope className="icon" /> Mail us: support@altrange.com
        </p>
      </div>
    </div>
  );
};

export default ContactSupport;